export const applicationMessagePrefix = '!';
